// require sources
import _Quill from 'quill'

const Quill = window.Quill || _Quill

let Inline = Quill.import('blots/inline')

class Font extends Inline {
  static create ({style}) {
    let node = document.createElement('span')
    node.setAttribute('style', style)
    return node
  }

  static formats (node) {
    let style = ''
    if (node.getAttribute('color')) {
      style += `color:${node.color};`
    }
    return {style}
  }
}

Font.blotName = 'font'
Font.tagName = 'font'

Quill.register(Font)



// WEBPACK FOOTER //
// ./src/components/vue-quill-editor/formats/font.js